import { useCalculatedTimeDifference } from "./CalculatedTimeDifference";
import { onDateFormate } from "./DateFormate";

export const generateFormattedData = (
  data,
  type,
  user,
  depositWaitingQueue,
  depositVerifactionTab,
  startIndex = 0,
) => {
  return data.map((item, index) => {
    const calculatedTimeDifference = useCalculatedTimeDifference();
    const isVendor =
      item?.actionBy?.userType === "vendor" && user?.userType === "vendor";
    const isOperator =
      item?.actionBy?.userType === "operator" &&
      item?.actionBy?.userType === "operator" &&
      user?._id === item?.actionBy?._id;

    let userId =
      type === "depositReport"
        ? item.sender?.uniqueId
        : item.user?.uniqueId || "-";

    let websiteName =
      type === "depositReport"
        ? item?.senderWebsite?.name
        : item?.website?.name || "-";

    let websiteNameId =
      type === "depositReport"
        ? item?.senderWebsite?.uniqueId
        : item?.website?.uniqueId || "-";

    const formattedData = {
      "Sr No": startIndex + index + 1,
      Status: item.status || "-",
      ...(type !== "depositReport" && {
        "Request Process":
          item?.isDepositReqAutoApproval === false
            ? "Auto to Manual"
            : item?.isDepositReqAutoApproval === true
              ? "Move to Manual"
              : "Manual",
      }),
      ...(type === "depositReport" && {
        "Request Process":
          item?.isDepositReqAutoApproval === true
            ? "Auto"
            : item?.isDepositReqAutoApproval === false
              ? "Auto to Manual"
              : "Manual",
      }),
      "UTR ID":
        item?.reqType === "upi" && item?.transactionId
          ? `${item?.transactionId} ${
              item?.upiId ? `[${item?.upiId ? item?.upiId : "-"}]` : ""
            }`
          : "-" || "-",
      "UTR Transaction ID": item?.gatewayTraId || "-",
      ...((type === "depositReport" || depositVerifactionTab) && {
        "Change UTR Transaction ID": item?.changeGatewayTraId || "-",
      }),
      "PG Transaction ID": item?.traId || "-",
      Amount: item.amount || "-",
      ...((type === "depositReport" || depositVerifactionTab) && {
        "User Amount": item?.changeAmount || "-",
      }),
      "Received Amount": item.receivedAmount || "-",
      ...(type !== "depositReport" && {
        "Transaction Process": item?.isManualDepositOrder ? "Link" : "Website",
      }),
      ...(type === "depositReport" && {
        "Transaction Process": item?.isManualOrder ? "Link" : "Website",
        "User Name": item?.sender?.name ? item?.sender?.name : "-",
      }),
      "User Id": userId,
      Coin: item?.coin?.name || "-",
      "Crypto Amount": item?.usdtAmount || "-",
      "Coin Network": item.coinNetwork?.name || "-",
      "Request Type": item.reqType,
      ...(depositVerifactionTab && {
        "Action By":
          isVendor || isOperator ? "Own" : item.actionBy?.name || "-",
      }),
      ...(type === "depositReport" && {
        "UPI ID":
          item.accountHistory && item.accountHistory.length > 0
            ? item.accountHistory[1]?.transferAccount?.upiId || "-"
            : item?.receiverAccount?.upiId || "-",
        "Account Holder Name":
          item.accountHistory && item.accountHistory.length > 0
            ? item.accountHistory[1]?.transferAccount?.name || "-"
            : item?.receiverAccount?.name || "-",
        "Bank Name":
          item.accountHistory && item.accountHistory.length > 0
            ? item.accountHistory[1]?.transferAccount?.bankName || "-"
            : item?.receiverAccount?.bankName || "-",
        "Account Number":
          item.accountHistory && item.accountHistory.length > 0
            ? item.accountHistory[1]?.transferAccount?.accountNum || "-"
            : item?.receiverAccount?.accountNum || "-",
        IFSC:
          item.accountHistory && item.accountHistory.length > 0
            ? item.accountHistory[1]?.transferAccount?.ifsc || "-"
            : item?.receiverAccount?.ifsc || "-",
        "Action Type": item.actionBy ? item.actionBy.name : "Own",
      }),
      ...(type !== "depositReport" && {
        "UPI ID": item?.depositAccount?.upiId
          ? item?.depositAccount?.upiId
          : "-",
        "Bank Name": item?.depositAccount?.bankName
          ? item?.depositAccount?.bankName
          : "-",
        "Account Number": item?.depositAccount?.accountNum
          ? item?.depositAccount?.accountNum
          : "-",
        IFSC: item?.depositAccount?.ifsc ? item?.depositAccount?.ifsc : "-",
      }),
      ...(user?.userType !== "operator" &&
        type === "depositReport" && {
          "Action By": item?.paymentGateway
            ? item?.paymentGateway?.name
            : item?.actionBy?.userType === "admin"
              ? "TES"
              : item?.receiverAccountOwnerType === "vendor" && item?.actionBy
                ? item?.actionBy?.uniqueId
                : item?.receiverAccountOwnerType === "vendor" && !item?.actionBy
                  ? item?.receiver?.uniqueId
                  : item?.actionBy
                    ? item?.actionBy
                    : "Own",
        }),
      ...(user?.userType === "operator" &&
        type === "depositReport" && {
          "Action By": item?.actionBy ? "Own" : item?.receiver?.name,
        }),
      "Created Date":
        onDateFormate(item.createdAt, "DD-MM-YYYY hh:mm:ss A") || "-",
      "Updated Date":
        onDateFormate(item.updatedAt, "DD-MM-YYYY hh:mm A") || "-",
      ...(user?.userType !== "operator" && {
        "Website Name": websiteName,
        "Website Id": websiteNameId,
      }),

      // Deposit Queue then Receiver Name Show like this
      ...(type !== "depositReport" && {
        "Receiver Name":
          item?.depositAccountOwnerType === "vendor"
            ? "-"
            : item?.paymentGateway?.name
              ? item?.paymentGateway?.name
              : item?.created?.name,
        "Receiver Id": item?.paymentGateway
          ? "PG"
          : user?.userType !== "operator" ||
              item?.depositAccountOwnerType !== "vendor"
            ? item?.created?.uniqueId
            : "-",
        "Receiver Type": item?.paymentGateway
          ? "PG"
          : item?.receiverAccountOwnerType?.toUpperCase(),
      }),

      // Deposite Report then Receiver Show like this
      ...(type === "depositReport" && {
        "Receiver Name":
          user?.userType === "operator" ||
          item?.receiverAccountOwnerType === "vendor"
            ? "-"
            : item?.paymentGateway?.name
              ? item?.paymentGateway?.name
              : item?.receiver?.name,
        "Receiver Id": item?.paymentGateway?.name
          ? "PG"
          : user?.userType !== "operator" ||
              item?.depositAccountOwnerType !== "vendor"
            ? item?.receiver?.uniqueId
            : "-",
        "Receiver Type": item?.paymentGateway
          ? "PG"
          : item?.receiverAccountOwnerType?.toUpperCase(),
      }),

      "Assign To":
        item?.depositAccountOwnerType === "website"
          ? `Website`
          : item?.depositAccountOwnerType === "vendor"
            ? `Vendor`
            : `Own`,
      ...(type === "depositReport" && {
        "Time Differenece":
          calculatedTimeDifference(item?.createdAt, item?.updatedAt) || "-",
        Remarks: item?.remark || "-",
      }),
      ...(type !== "depositReport" &&
        depositWaitingQueue && {
          "Waiting Queue": item?.depositWaitingTime || "-",
        }),
      Image: item?.reqType === "bank" ? item.paymentSS : "-" || "-",
    };
    return formattedData;
  });
};

export const generateWithdrawReportFormattedData = (
  data,
  type,
  user,
  startIndex = 0,
) => {
  return data.map((item, index) => {
    const calculatedTimeDifference = useCalculatedTimeDifference();

    const formattedData = {
      "Sr No": startIndex + index + 1,
      "PG Transaction ID": item?.traId || "-",
      "UTR Transaction ID": item?.gatewayTraId || "-",
      "User Name": item?.receiver.name || "-",
      "User ID": item?.receiver.uniqueId || "-",
      ...(user?.userType !== "operator" && {
        "Website Name": item?.senderWebsite?.name || "-",
      }),
      ...(user?.userType !== "operator" && {
        "Website Id": item?.senderWebsite?.uniqueId || "-",
      }),
      Amount: item.amount || "-",
      "Transaction Process": item.isManualOrder ? "Link" : "Website",
      "Payment Gateway":
        item.isPaymentGatewaySuccess && item?.paymentGateway
          ? item?.paymentGateway.name
          : item?.paymentGateway
            ? item?.paymentGateway.name
            : "-",
      "Payment Gateway Status":
        !item.isPaymentGatewaySuccess && item?.paymentGateway ? "Failed" : "-",
      "Request Type": item.reqType || "-",
      "Sender Name":
        item?.receiverAccountOwnerType === "website"
          ? item.senderWebsite?.name
          : item?.receiverAccountOwnerType === "vendor" && item?.actionBy
            ? "operator"
            : item?.receiverAccountOwnerType === "vendor"
              ? "vendor"
              : item?.sender?.name,
      "Sender Id":
        item?.receiverAccountOwnerType === "website"
          ? item.senderWebsite?.uniqueId
          : item?.sender?.uniqueId,
      "Sender Type": item.receiverAccountOwnerType || "-",
      ...(user?.userType !== "operator" && {
        "Action By": item?.actionBy
          ? item?.actionBy?.uniqueId
          : item?.sender?.uniqueId
            ? item?.sender?.uniqueId
            : "-",
      }),
      ...(user?.userType === "operator" && {
        "Action By":
          item?.actionBy ||
          item?.receiverAccountOwnerType === "agent" ||
          item?.receiverAccountOwnerType === "website"
            ? "Own"
            : user?.userType === "operator" && !item?.actionBy
              ? item?.senders?.name
              : item?.actionBy
                ? item?.actionBy
                : item?.sender?.uniqueId,
      }),
      "Receiver Account Type": item?.receiverAccount?.type || "-",
      "Receiver UPI ID": item?.receiverAccount?.upiId || "-",
      "Receiver Bank Name": item?.receiverAccount?.bankName || "-",
      "Receiver Bank Holder Name": item?.receiverAccount?.accHolderName || "-",
      "Receiver Account No": item?.receiverAccount?.accountNum || "-",
      "Receiver IFSC": item?.receiverAccount?.ifsc || "-",
      "Receiver Network": item?.receiverAccount?.network || "-",
      "Receiver Wallet Address":
        item?.receiverAccount?.cryptoWalletAddress || "-",
      "Sender Account Type": item?.senderAccount?.type || "-",
      "Sender UPI ID": item?.senderAccount?.upiId || "-",
      "Sender Bank Name": item?.senderAccount?.bankName || "-",
      "Sender Bank Holder Name": item?.senderAccount?.name || "-",
      "Sender Account No": item?.senderAccount?.accountNum || "-",
      "Sender IFSC": item?.senderAccount?.ifsc || "-",
      "Sender Network": item?.senderAccount?.network || "-",
      "Sender Wallet Address": item?.senderAccount?.cryptoWalletAddress || "-",
      "Created Date":
        onDateFormate(item.withdrawReqCreatedAt, "DD-MM-YYYY hh:mm:ss A") || "-",
      "Updated Date":
        onDateFormate(item.updatedAt, "DD-MM-YYYY hh:mm:ss A") || "-",
      "Time Difference":
        calculatedTimeDifference(
          item?.withdrawReqCreatedAt
            ? item?.withdrawReqCreatedAt
            : item?.depositReqCreatedAt,
          item.updatedAt,
        ) || "-",
      Status: item.status || "-",
      Remarks: item?.remark || "-",
    };

    return formattedData;
  });
};

export const generateWebsiteReportData = (data) => {
  return data.map((item, index) => {
    const formattedData = {
      "Sr No": index + 1,
      "Website Name": item.name,
      "Website Id": item.uniqueId,
      "Deposite Success": item?.transactions?.totalDepositAmount
        ? (item?.transactions?.totalDepositAmount).toFixed(2)
        : "00",
      "Withdraw Success": item?.transactions?.totalWithdrawAmount
        ? (item?.transactions?.totalWithdrawAmount).toFixed(2)
        : "00",
      DMW:
        item?.transactions?.totalDepositAmount ||
        item?.transactions?.totalWithdrawAmount
          ? (
              item?.transactions?.totalDepositAmount -
              item?.transactions?.totalWithdrawAmount
            ).toFixed(2)
          : "00",
    };
    return formattedData;
  });
};

export const generatePGReportData = (data) => {
  return data.map((item, index) => {
    const formattedData = {
      "Sr No": index + 1,
      "Website Name": item.name,
      "Deposite Success": item?.transactions?.totalDepositAmount
        ? (item?.transactions?.totalDepositAmount).toFixed(2)
        : "00",
      "Deposit Count": item?.transactions?.totalDepositCount
        ? (item?.transactions?.totalDepositCount).toFixed(2)
        : "00",
      "Withdraw Success": item?.transactions?.totalWithdrawAmount
        ? (item?.transactions?.totalWithdrawAmount).toFixed(2)
        : "00",
      "Withdraw Count": item?.transactions?.totalWithdrawCount
        ? (item?.transactions?.totalWithdrawCount).toFixed(2)
        : "00",
      DMW:
        item?.transactions?.totalDepositAmount ||
        item?.transactions?.totalWithdrawAmount
          ? (
              item?.transactions?.totalDepositAmount -
              item?.transactions?.totalWithdrawAmount
            ).toFixed(2)
          : "00",
    };
    return formattedData;
  });
};

export const generateWithdrawQueueFormattedData = (data, type, user) => {
  return data.map((item, index) => {
    const formattedData = {
      "Sr No": index + 1,
      Status:
        item?.status === "verified" && item?.isBalanceVerified === true
          ? "Verified"
          : item?.status === "verified"
            ? "Verify Balance"
            : item?.status,
      "Payment Gateway": item?.paymentGateway?.name || "-",
      "Payment Gateway Status":
        item?.status === "verified" && item?.paymentGateway ? "Failed" : "-",
      "UPI ID": item?.accountId?.upiId || "-",
      Amount: item.amount || "-",
      "Pending Amount": item?.pendingAmount || "00",
      "Paid Amount": item?.paidAmount || "00",
      "Transaction Process ": item?.isManualWithdrawOrder
        ? "Link"
        : "Website" || "-",
      "PG Transaction ID": item?.traId || "-",
      "User ID": item?.user?.uniqueId || "-",
      "Request Type": item?.reqType || "-",
      "Bank Name":
        item?.accountId?.type === "crypto"
          ? item?.accountId?.coin
          : item?.accountId?.bankName || "-",
      "Account No":
        item?.accountId?.type === "crypto"
          ? item?.accountId?.address
          : item?.accountId?.accountNum || "-",
      IFSC:
        item?.accountId?.type === "crypto"
          ? item?.accountId?.network
          : item?.accountId?.ifsc || "-",
      "Created Date":
        onDateFormate(item.createdAt, "DD-MM-YYYY hh:mm:ss A") || "-",
      "Updated Date":
        onDateFormate(item.updatedAt, "DD-MM-YYYY hh:mm:ss A") || "-",
      "Expired Time":
        onDateFormate(item.expiry, "DD-MM-YYYY hh:mm:ss A") || "-",

      // When operator Website Not show
      ...(user?.userType !== "operator" && {
        "Website Name": item?.website?.name || "-",
      }),
      ...(user?.userType !== "operator" && {
        "Website Id": item?.website?.uniqueId || "-",
      }),

      "Receiver Name":
        item?.status === "pgInProcess" && item?.paymentGateway
          ? "PG"
          : item?.agentId
            ? item?.agent?.name
            : item?.vendorId === null && item?.vendorId === null
              ? item?.website?.name
              : "-",
      "Receiver Id": item?.vendorId
        ? item?.vendor?.uniqueId
        : item?.agentId
          ? item?.agent?.uniqueId
          : item?.vendorId === null && item?.vendorId === null
            ? item?.website?.uniqueId
            : "-",
      "Assign To":
        item?.withdrawAccountOwnerType === "vendor"
          ? "Vendor"
          : item?.withdrawAccountOwnerType === "pg"
            ? "PG"
            : item?.withdrawAccountOwnerType === "website"
              ? "Website"
              : "Own" || "-",
    };

    return formattedData;
  });
};

export const generateTransactionListReportData = (data) => {
  return data.map((item, index) => {
    const formattedData = {
      "Sr No": index + 1,
      Date: onDateFormate(item.createdAt, "DD-MM-YYYY hh:mm A") || "-",
      "PG Transaction ID": item?.traId || "-",
      "Receiver Account":
        item?.receiverAccount?.name || item?.depositAccount?.name || "-",
      "Receiver Type":
        item?.receiver?.userType || item?.depositAccount?.owner || "-",
      "Receiver Name": item?.receiver?.name || item?.created?.name || "-",
      Amount: item?.amount || "-",
      "Received Amount": item?.receivedAmount || "-",
      Status: item?.status || "-",
    };

    return formattedData;
  });
};
